<template>
  <div>
    <div v-if="loading" class="C-PageLoading">
      <div class="Spinner spinner-grow text-primary"></div>
    </div>
    <div v-if="!loading" class="row">
      <el-col class="LeftPart">
        <!--基本详情-->
        <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
          <div class="imgrow">
            <div class="Picture" v-for="(item,index) of imgList" :key="index">
              <el-image
                class="imglist"
                :src="item"
                fit="cover"
                :preview-src-list="imgList">
              </el-image>
            </div>
          </div>
          <div class="G-title" style="margin-bottom: 5px"></div>
          <div class="InfoField">
            <div class="InfoHead" style="font-weight: bold;font-size: 16px">
                  {{title}}
              <div>
                <div class="ant-tag" v-if="type === 2">曝光</div>
                <div class="ant-tag" v-if="type === 1">商家</div>
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <svg-icon icon-class="address" style="fill:#f39"></svg-icon>
                <span style="color: #ff3399">{{city}}</span>
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <div><p class="mb-2" style="white-space: pre-line !important;">{{process}}</p></div>
              </div>
            </div>
          </div>
        </el-card>
        <!--联系方式-->
        <el-card shadow="never" style="user-select: auto" :body-style="{padding: '16px',textAlign: 'left'}">
          <div class="InfoField" v-if="!$store.getters.Flag">
            <div class="G-title">
              <span><svg-icon icon-class="call" style="margin-right: 5px"></svg-icon>联系方式</span>
            </div>
            <div style="padding-top: 5px;" >
              <p style="font-size: 16px">您需要
                <router-link to="/login" style="color: #f39;font-size: 16px">登录</router-link>
                才可继续查看联系方式</p>
              <el-button plain @click="$router.push('/login')" size="medium" round>立即登录</el-button>
            </div>
          </div>
          <div class="InfoField" v-if="$store.getters.Flag">
            <div class="G-title">
              <span><svg-icon icon-class="call" style="margin-right: 5px"></svg-icon>联系方式</span>
            </div>
            <div v-if="is_see">
              <div class="Profiles" v-if="QQ">
                <div class="Profile">
                  <span class="g">QQ：</span>
                  <span>{{QQ}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="wechat">
                <div class="Profile">
                  <span class="g">微信：</span>
                  <span>{{wechat}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="telegram">
                <div class="Profile">
                  <span style="font-weight: bold">telegram：</span>
                  <span>{{telegram}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="phone">
                <div class="Profile">
                  <span class="g">电话：</span>
                  <span>{{phone}}</span>
                </div>
              </div>
              <div class="Profiles" v-if="address">
                <div class="Profile">
                  <span class="g">地址：</span>
                  <span>{{address}}</span>
                </div>
              </div>
            </div>
            <div v-if="!is_see && is_points || !is_see">
              <div style="padding-top: 5px;" >
                <p style="font-size: 16px">本信息的联系方式仅
                  <span style="color: #f39;font-size: 16px">VIP会员</span>
                  才能查看
                </p>
              </div>
            </div>
            <div class="Profiles">
              <div class="Profile">
                <router-link to="/upgrade" style="color: #f39" v-if="!is_see" class="navbar-nav">
                  <el-button size="small"><span style="font-size: 14px">升级VIP</span></el-button>
                </router-link>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col class="RightPart">
        <el-card shadow="hover" :body-style="{padding: '0px',height: '100%'}" style="margin-top: 8px;">
            <div class="G-title" style="padding: 15px" >
              <span>风险提示</span>
            </div>
          <div style="margin: 10px;text-align: left; font-size: 14px;">
            本站为信息分享平台，并不对寻欢经历负责，请注意个人防范。凡是在联系方式上要求提前付费等类似行为的商家都是骗子商家，请特别警惕推荐办卡行为商家以及引导下载APP的商家，请勿上当受骗。碰到有问题的信息，请注意保护自己并举报给我们删除信息，投诉邮箱fengloukefu@gmail.com
          </div>
        </el-card>
        <el-card shadow="hover" :body-style="{padding: '0px',height: '100%'}" style="margin-top: 8px;">
          <div style="margin: 10px;text-align: left; font-size: 14px;text-align: center;font-weight: bold">
            如果你有兴趣入驻商家，点击下方了解。
          </div>
          <div style="margin: 15px">
            <router-link to="/merchantjoin" style="color: #f39" class="navbar-nav">
              <el-button size="small"><span style="font-size: 14px">商家入驻</span></el-button>
            </router-link>
          </div>
        </el-card>
      </el-col>
    </div>
  </div>
</template>

<script>
import RightPart from '@/components/widget/RightPart'
import {request} from '../../network/request'
export default {
  name: 'merchant_show',
  components: {RightPart},
  data () {
    let validateContent = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('举报原因不能为空'))
      } else if (value.length < 10 || value.length > 200) {
        callback(new Error('举报原因 必须介于 10 - 200 个字符之间。'))
      } else {
        callback()
      }
    }
    let validateRetype = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择举报原因'))
      } else {
        callback()
      }
    }
    return {
      setReBtn: false,
      is_points: false,
      loading: true,
      // 传入推荐的值
      r_data: [],
      // 信息详情
      is_see: true,
      type: 0,
      id: this.$route.query.id,
      title: '',
      time: '',
      browse: '',
      city: '',
      cid: '',
      age: '',
      face: '',
      price: '',
      project: '',
      points: 0,
      QQ: '',
      wechat: '',
      telegram: '',
      phone: '',
      address: '',
      process: '',
      privacy: '',
      imgList: [],
      fav: 0,
      rules: {
        content: [
          {validator: validateContent, trigger: 'blur'}
        ],
        reType: [
          {validator: validateRetype, trigger: 'blur'}
        ]
      }
    }
  },
  watch: {
    '$route': {
      handler (newVal) {
        if (!this.$route.query.id) {
          this.loading = true
        } else {
          this.loading = true
          this.id = this.$route.query.id
          this.get_data(this.id)
        }
      }
    }
  },
  created () {
    if (!this.$route.query.id) {
      this.loading = true
    } else {
      this.get_data(this.id)
    }
  },
  methods: {
    get_data (id) {
      let data = new URLSearchParams()
      data.append('id', id)
      request({
        url: '/api/show',
        method: 'post',
        data: data
      }).then(res => {
        this.telegram = res.data.telegram
        this.title = res.data.title
        this.time = res.data.time
        this.browse = res.data.browse
        this.city = res.data.city
        this.cid = res.data.cid
        this.age = res.data.age
        this.face = res.data.face
        this.price = res.data.price
        this.project = res.data.project
        this.QQ = res.data.QQ
        this.wechat = res.data.wechat
        this.phone = res.data.phone
        this.address = res.data.address
        this.process = res.data.process
        this.imgList = res.data.imgList
        this.type = res.data.type
        this.points = res.data.points
        this.r_data = res.data.r_data
        this.fav = res.data.fav
        this.is_points = res.data.is_points
        this.is_see = res.data.is_see
        this.privacy = res.data.privacy
        this.loading = false
        if (this.type !== 1) {
          this.$router.push('/index')
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
p {
  display: block;
  font-size: .875rem;
  line-height: 1.5rem;
}
.p4 {
  font-size: 14px;
  color: #f39;
}
.row {
  margin: -8px 0 0 !important;
  justify-content: space-between !important;
  display: flex;
  flex-wrap: wrap;
}
.InfoTitle {
  font-size: 16px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-secondary {
  color: #999 !important;
}

small {
  font-size: 80%;
  font-weight: 400;
}

.pr-2 {
  padding-right: .5rem !important;
}

.Profiles {
  padding: 0 !important;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.svg-icon {
  width: 1.1em;
  height: 1.1em;
  vertical-align: -0.2em;
  fill: currentColor;
}

.G-title {
  font-size: 16px;
  border-bottom: 1px solid #f2f2f2 !important;
  color: #333 !important;
  padding: 5px;
  justify-content: space-between !important;
  display: flex !important;
}

.g {
  display: inline-block;
  width: 42px;
  font-weight: 700 !important;
}
.imgrow{
  display: grid;
  grid-template-columns: repeat(4,minmax(0,1fr));
}
.Picture {
  box-sizing:border-box;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  padding-left: 5px;
  padding-top: 5px;
}
.imglist{
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
img{
  border-style: none;
  vertical-align: middle;
}
.mb-2{
  font-size: 14px
}
a:hover{
  text-decoration:underline;
}
.text-dark {
  color: black;
  font-weight: 700 !important;
  margin-top: .5rem !important;
  margin-bottom: .5rem !important;
  font-size: 14px;
}
.m2 {
  margin-bottom: .5rem;
  margin-top: .5rem;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/merchant_show.vue